module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Users/Mee/Desktop/annual-summary-2017/node_modules/core-js/library/modules/_iter-step.js
// module id = f4iN
// module chunks = 0